export default "__VITE_ASSET__BGbexnOF__"